/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2022, Zumper
 */

// https://chakra-ui.com/docs/styled-system/theming/component-style#styling-single-part-components

import type { ComponentStyleConfig } from '@chakra-ui/theme'
import { SystemStyleFunction, mode } from '@chakra-ui/theme-tools'

import {
  secondaryDark,
  secondaryDarkHover,
  secondaryLight,
  secondaryLightHover,
} from '../constants'
import { focus } from '../sharedStyles'

const variantMain: SystemStyleFunction = (props) => ({
  color: mode('gray.950', 'gray.0'),
  _hover: {
    color: mode('gray.600', 'gray.100')(props),
  },
})

const variantContrast: SystemStyleFunction = (props) => ({
  color: mode('gray.600', 'gray.100')(props),
  _hover: {
    color: mode('gray.950', 'gray.0')(props),
  },
})

const variantMini: SystemStyleFunction = (props) => ({
  color: mode('gray.950', 'gray.0')(props),
  fontSize: 'md',
  _hover: {
    color: mode('gray.600', 'gray.100')(props),
  },
})

const variantSecondary: SystemStyleFunction = (props) => ({
  color: mode(secondaryLight, secondaryDark)(props),
  _hover: {
    color: mode(secondaryLightHover, secondaryDarkHover)(props),
  },
})

const baseStyle = {
  fontFamily: 'body',
  fontSize: 'md',
  textDecoration: 'underline',
  margin: 0,
  padding: 0,
  _focus: {
    outline: 'none',
    boxShadow: 'none',
  },
  _focusVisible: focus,
}

const variants = {
  main: variantMain,
  contrast: variantContrast,
  mini: variantMini,
  secondary: variantSecondary,
}

export const Z4Link: ComponentStyleConfig = {
  defaultProps: {
    variant: 'main',
  },
  baseStyle,
  variants,
}
